/**
 * Truncates text by showing the start and end with an ellipsis in the middle.
 */
export function truncateMiddle(
  text: string,
  firstChars: number,
  lastChars: number
): string {
  const middleEllipsis = ' ... '

  if (!text) return ''
  if (text.length <= firstChars + lastChars + middleEllipsis.length) {
    return text
  }

  return `${text.slice(0, firstChars)}${middleEllipsis}${text.slice(-lastChars)}`
}
